import type { ReactNode } from 'react';
import AccountBoxTwoToneIcon from '@mui/icons-material/AccountBoxTwoTone';
import TuneIcon from '@mui/icons-material/Tune';
//import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import PaymentsIcon from '@mui/icons-material/Payments';

export interface MenuItem {
  query?: string;
  icon?: ReactNode;
  name: string;
  isDisabled?: boolean;
}

const menuItems: MenuItem[] = [
  {
    name: 'My profile',
    icon: AccountBoxTwoToneIcon,
    query: 'user-profile'
  },
  {
    name: 'Preferences',
    icon: TuneIcon,
    query: 'preferences'
  },
  // {
  //   name: 'Privacy',
  //   icon: VerifiedUserIcon,
  //   query: 'privacy'
  // },
  {
    name: 'Plans & payments',
    icon: PaymentsIcon,
    query: 'payments'
  }
];

export default menuItems;
